import { useMutation } from '@tanstack/react-query';
import { publishParkingContract } from '../../api/parking-contract.ts';

export default function useDeleteParkingContract() {
  return useMutation({
    mutationFn: ({ partnerId, id }: { partnerId: string; id: string }) =>
      publishParkingContract(partnerId, id),
  });
}
